/* eslint-disable */
/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
/* global FullCalendar */

const calendar = () => {
  const calendarEl = document.querySelector('.js-calendar-view');
  const addOrUpdateUrlParam = (name, value) => {
    const { href } = window.location;
    let regex = new RegExp(`[&\\?]${name}=`);
    if (regex.test(href)) {
      regex = new RegExp(`([&\\?])${name}=\\d+`);
      return href.replace(regex, `$1${name}=${value}`);
    }

    if (href.indexOf('?') > -1) return `${href}&${name}=${value}`;
    return `${href}?${name}=${value}`;
  };
  const newURL = addOrUpdateUrlParam('json', 1);
  // let mobileAndTabletCheck = () => {
  //   let check = false;
  //   (function(a) {
  //     if (
  //       /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
  //         a,
  //       ) ||
  //       /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
  //         a.substr(0, 4),
  //       )
  //     )
  //       check = true;
  //   })(navigator.userAgent || navigator.vendor || window.opera);
  //   return check;
  // };
  let mobileAndTabletCheck = () => {
    let check = false;
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth <= 1024) {
      check = true;
    }
    return check;
  };
  if (calendarEl) {
    const { mode } = calendarEl.dataset;
    if (calendarEl) {
      const initialMode = mobileAndTabletCheck()
        ? `list${mode.charAt(0).toUpperCase()}${mode.slice(1)}`
        : `dayGrid${mode.charAt(0).toUpperCase()}${mode.slice(1)}`;
      document.events = [];
      const calendarObj = new FullCalendar.Calendar(calendarEl, {
        initialView: initialMode,
        locale: document.querySelector('html').getAttribute('lang'),
        height: 'auto',
        customButtons: {
          miniCal: {
            text: '',
            click() {
              // alert('clicked the custom button!');
            },
          },
        },
        views: {
          dayGridYear: {
            type: 'listYear',
            // listDayFormat: { month: 'long' },
            // listDaySideFormat: false,
            titleFormat: { year: 'numeric' },
          },
          dayGridMonth: {
            titleFormat: { month: 'long', year: 'numeric' },
          },
          dayGridWeek: {
            titleFormat: { month: 'long', day: 'numeric' },
          },
        },
        dayHeaderFormat: { weekday: 'long' },
        headerToolbar: {
          start: 'today',
          center: 'title,miniCal',
          end: 'prev next',
          today: 'Dzisiaj',
        },
        eventSources: [
          {
            url: newURL,
            color: '#e6f0f9',
            textColor: '#0063C1',
            borderColor: '#0063C1',
          },
        ],
        eventClassNames: ['js-event'],
        eventContent: (arg, createElement) => {
          if (arg.view.type === 'dayGridYear') {
            return {
              html: `<div class="fc-event-main-frame"><div class="fc-event-title-container"><div class="fc-event-title fc-sticky">${
                arg.event.title
              }</div></div></div>`,
            };
          }
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
          if (arg.event.end && viewportWidth > 767) {
            if (document.events[arg.event._instance.instanceId]) {
              document.events[arg.event._instance.instanceId]++;
            } else {
              document.events[arg.event._instance.instanceId] = 1;
              document.events[`time-${arg.event._instance.instanceId}`] = false;
            }
            if (!document.events[`time-${arg.event._instance.instanceId}`]) {
              let diffTime =
                arg.event.end.getTime() - arg.event.start.getTime();
              document.events[`time-${arg.event._instance.instanceId}`] =
                diffTime / (1000 * 3600 * 24);
            }
            return {
              html: `<div class="fc-event-main-frame c-event"><div class="fc-event-title-container"><div class="fc-event-title fc-sticky">${
                arg.event.title
              } <span class="fc-event-counter">(${
                document.events[arg.event._instance.instanceId]
              }/${
                document.events[`time-${arg.event._instance.instanceId}`]
              })</span></div></div>${arg.event.extendedProps.popup}</div>`,
            };
          }
          return { html: arg.event.extendedProps.html };
        },
      });
      calendarObj.render();
    }
  }
};

export default calendar;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/calendar.js